'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_types\uff3fpostcodes$package$UKPostcode$() {
  this.Lapp_data_types\uff3fpostcodes$package$UKPostcode$__f_defaultMake$lzy1 = null;
  this.Lapp_data_types\uff3fpostcodes$package$UKPostcode$__f_defaultMakebitmap$1 = false;
  this.Lapp_data_types\uff3fpostcodes$package$UKPostcode$__f_make$lzy1 = null;
  this.Lapp_data_types\uff3fpostcodes$package$UKPostcode$__f_makebitmap$1 = false;
  this.Lapp_data_types\uff3fpostcodes$package$UKPostcode$__f_validator = null;
  this.Lapp_data_types\uff3fpostcodes$package$UKPostcode$__f_given_Show_Type$lzy1 = null;
  this.Lapp_data_types\uff3fpostcodes$package$UKPostcode$__f_given_Show_Typebitmap$1 = false;
  this.Lapp_data_types\uff3fpostcodes$package$UKPostcode$__f_schema$lzy1 = null;
  this.Lapp_data_types\uff3fpostcodes$package$UKPostcode$__f_schemabitmap$1 = false;
  $n_Lapp_data_types\uff3fpostcodes$package$UKPostcode$ = this;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lyantl_Validator$();
  var rules = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
    var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
    var getLength = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$3) => _$3.length));
    var $x_2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lyantl_ValidatorRule$$anon$9(getLength, 5);
    var getLength$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$4) => _$4.length));
    var $x_1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lyantl_ValidatorRule$$anon$10(getLength$1, 7);
    var this$8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lyantl_ValidatorRule$$anon$12();
    var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$5) => _$5));
    return $x_3.wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lyantl_ValidatorRule.getArrayOf().constr)([$x_2, $x_1, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lyantl_ValidatorRule$$anon$2(f, this$8)]));
  }));
  this.Lapp_data_types\uff3fpostcodes$package$UKPostcode$__f_validator = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_Validator$$anon$6(rules);
}
export { $c_Lapp_data_types\uff3fpostcodes$package$UKPostcode$ as $c_Lapp_data_types\uff3fpostcodes$package$UKPostcode$ };
$c_Lapp_data_types\uff3fpostcodes$package$UKPostcode$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_types\uff3fpostcodes$package$UKPostcode$.prototype.constructor = $c_Lapp_data_types\uff3fpostcodes$package$UKPostcode$;
/** @constructor */
function $h_Lapp_data_types\uff3fpostcodes$package$UKPostcode$() {
}
export { $h_Lapp_data_types\uff3fpostcodes$package$UKPostcode$ as $h_Lapp_data_types\uff3fpostcodes$package$UKPostcode$ };
$h_Lapp_data_types\uff3fpostcodes$package$UKPostcode$.prototype = $c_Lapp_data_types\uff3fpostcodes$package$UKPostcode$.prototype;
$c_Lapp_data_types\uff3fpostcodes$package$UKPostcode$.prototype.defaultMake__Lyantl_INewtype$defaultMake$ = (function() {
  if ((!this.Lapp_data_types\uff3fpostcodes$package$UKPostcode$__f_defaultMakebitmap$1)) {
    this.Lapp_data_types\uff3fpostcodes$package$UKPostcode$__f_defaultMake$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$defaultMake$(this);
    this.Lapp_data_types\uff3fpostcodes$package$UKPostcode$__f_defaultMakebitmap$1 = true;
  }
  return this.Lapp_data_types\uff3fpostcodes$package$UKPostcode$__f_defaultMake$lzy1;
});
$c_Lapp_data_types\uff3fpostcodes$package$UKPostcode$.prototype.make__Lyantl_INewtype$make$ = (function() {
  if ((!this.Lapp_data_types\uff3fpostcodes$package$UKPostcode$__f_makebitmap$1)) {
    this.Lapp_data_types\uff3fpostcodes$package$UKPostcode$__f_make$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lyantl_INewtype$make$(this);
    this.Lapp_data_types\uff3fpostcodes$package$UKPostcode$__f_makebitmap$1 = true;
  }
  return this.Lapp_data_types\uff3fpostcodes$package$UKPostcode$__f_make$lzy1;
});
$c_Lapp_data_types\uff3fpostcodes$package$UKPostcode$.prototype.resolveMake__Lyantl_Make = (function() {
  return this.defaultMake__Lyantl_INewtype$defaultMake$();
});
$c_Lapp_data_types\uff3fpostcodes$package$UKPostcode$.prototype.protected_unwrap__O__O = (function(wrapped) {
  return wrapped;
});
$c_Lapp_data_types\uff3fpostcodes$package$UKPostcode$.prototype.wrap__O__O = (function(underlying) {
  return underlying;
});
$c_Lapp_data_types\uff3fpostcodes$package$UKPostcode$.prototype.validate__Lyantl_Validate = (function() {
  return this.Lapp_data_types\uff3fpostcodes$package$UKPostcode$__f_validator;
});
$c_Lapp_data_types\uff3fpostcodes$package$UKPostcode$.prototype.given_Show_Type__Lcats_Show = (function() {
  if ((!this.Lapp_data_types\uff3fpostcodes$package$UKPostcode$__f_given_Show_Typebitmap$1)) {
    this.Lapp_data_types\uff3fpostcodes$package$UKPostcode$__f_given_Show_Type$lzy1 = new $c_Lapp_data_types\uff3fpostcodes$package$UKPostcode$$anon$2();
    this.Lapp_data_types\uff3fpostcodes$package$UKPostcode$__f_given_Show_Typebitmap$1 = true;
  }
  return this.Lapp_data_types\uff3fpostcodes$package$UKPostcode$__f_given_Show_Type$lzy1;
});
$c_Lapp_data_types\uff3fpostcodes$package$UKPostcode$.prototype.schema__Lsttp_tapir_Schema = (function() {
  if ((!this.Lapp_data_types\uff3fpostcodes$package$UKPostcode$__f_schemabitmap$1)) {
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var schemaType = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_SchemaType$SString();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var name = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var isOptional = false;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var description = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var default$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var format = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var encodedExample = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var deprecated = false;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var hidden = false;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var validator = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$();
    var attributes = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
    this.Lapp_data_types\uff3fpostcodes$package$UKPostcode$__f_schema$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lsttp_tapir_Schema(schemaType, name, isOptional, description, default$1, format, encodedExample, deprecated, hidden, validator, attributes).description__T__Lsttp_tapir_Schema("UK postcode").encodedExample__O__Lsttp_tapir_Schema("SW1A 1AA");
    this.Lapp_data_types\uff3fpostcodes$package$UKPostcode$__f_schemabitmap$1 = true;
  }
  return this.Lapp_data_types\uff3fpostcodes$package$UKPostcode$__f_schema$lzy1;
});
$c_Lapp_data_types\uff3fpostcodes$package$UKPostcode$.prototype.rawString__T__T = (function(value) {
  return value;
});
$c_Lapp_data_types\uff3fpostcodes$package$UKPostcode$.prototype.humanReadable__T__T = (function(value) {
  var raw = this.rawString__T__T(value);
  var x1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_StringOps$().splitAt$extension__T__I__T2(raw, (((-3) + raw.length) | 0));
  if ((x1 !== null)) {
    var x6 = x1._1__O();
    var x7 = x1._2__O();
    if (((x6 !== "") && (x7 !== ""))) {
      return ((x6 + " ") + x7);
    }
    if ((x6 !== "")) {
      return x6;
    }
    if ((x7 !== "")) {
      return x7;
    }
  }
  return "";
});
var $d_Lapp_data_types\uff3fpostcodes$package$UKPostcode$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_types\uff3fpostcodes$package$UKPostcode$, "app.data.types_postcodes$package$UKPostcode$", ({
  Lapp_data_types\uff3fpostcodes$package$UKPostcode$: 1,
  Lyantl_INewtype: 1,
  Lyantl_Newtype: 1,
  Lyantl_Newtype$ValidatedOf: 1
}));
export { $d_Lapp_data_types\uff3fpostcodes$package$UKPostcode$ as $d_Lapp_data_types\uff3fpostcodes$package$UKPostcode$ };
var $n_Lapp_data_types\uff3fpostcodes$package$UKPostcode$;
function $m_Lapp_data_types\uff3fpostcodes$package$UKPostcode$() {
  if ((!$n_Lapp_data_types\uff3fpostcodes$package$UKPostcode$)) {
    $n_Lapp_data_types\uff3fpostcodes$package$UKPostcode$ = new $c_Lapp_data_types\uff3fpostcodes$package$UKPostcode$();
  }
  return $n_Lapp_data_types\uff3fpostcodes$package$UKPostcode$;
}
export { $m_Lapp_data_types\uff3fpostcodes$package$UKPostcode$ as $m_Lapp_data_types\uff3fpostcodes$package$UKPostcode$ };
/** @constructor */
function $c_Lapp_data_types\uff3fpostcodes$package$UKPostcode$$anon$2() {
}
export { $c_Lapp_data_types\uff3fpostcodes$package$UKPostcode$$anon$2 as $c_Lapp_data_types\uff3fpostcodes$package$UKPostcode$$anon$2 };
$c_Lapp_data_types\uff3fpostcodes$package$UKPostcode$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_types\uff3fpostcodes$package$UKPostcode$$anon$2.prototype.constructor = $c_Lapp_data_types\uff3fpostcodes$package$UKPostcode$$anon$2;
/** @constructor */
function $h_Lapp_data_types\uff3fpostcodes$package$UKPostcode$$anon$2() {
}
export { $h_Lapp_data_types\uff3fpostcodes$package$UKPostcode$$anon$2 as $h_Lapp_data_types\uff3fpostcodes$package$UKPostcode$$anon$2 };
$h_Lapp_data_types\uff3fpostcodes$package$UKPostcode$$anon$2.prototype = $c_Lapp_data_types\uff3fpostcodes$package$UKPostcode$$anon$2.prototype;
$c_Lapp_data_types\uff3fpostcodes$package$UKPostcode$$anon$2.prototype.show__O__T = (function(t) {
  $m_Lapp_data_types\uff3fpostcodes$package$UKPostcode$();
  return t;
});
var $d_Lapp_data_types\uff3fpostcodes$package$UKPostcode$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_types\uff3fpostcodes$package$UKPostcode$$anon$2, "app.data.types_postcodes$package$UKPostcode$$anon$2", ({
  Lapp_data_types\uff3fpostcodes$package$UKPostcode$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_Show$ContravariantShow: 1,
  Lcats_Show: 1
}));
export { $d_Lapp_data_types\uff3fpostcodes$package$UKPostcode$$anon$2 as $d_Lapp_data_types\uff3fpostcodes$package$UKPostcode$$anon$2 };
//# sourceMappingURL=app.data.types_postcodes$package$-U-K-Postcode$.js.map
